import BrandLogo from "@/components/ui/BrandLogo.tsx";
import {Spinner} from "@/components/ui/Spinner.tsx";

export function FullScreenLoading() {
    return (
        <div className={"os-loading-overlay"}>
            <div className={"os-relative os-h-48 os-w-48"}>
                <Spinner className="os-h-48 os-w-48 os-absolute" />
                <BrandLogo className="os-h-48 os-w-48 os-p-10 os-absolute"/>
            </div>
            <div className={"os-text-xl"}>Processing your booking...</div>
        </div>
    );
}